import { createContext, useContext } from 'react';
import * as React from 'react';
import noop from '@sdk/utils/noop';

import { DraftMessagesProviderState } from '@web/conversations/DraftMessagesProvider/draftMessages.types';
import { DraftMessageSessionStoreCache } from '@web/conversations/DraftMessagesProvider/DraftMessageSessionStoreCache';

import { useDraftMessagesContext } from './draftMessages.hooks';

type Props = {
  children: React.ReactNode;
};

export const DraftMessagesProviderContext = createContext<DraftMessagesProviderState>({
  getDraftMessage: noop as any,
  setDraftMessage: noop as any,
  clearDraftMessage: noop as any,
} as DraftMessagesProviderState);
export const useDraftMessages = () => useContext(DraftMessagesProviderContext);

export const DraftMessagesProvider = ({ children }: Props) => {
  const draftMessagesState = useDraftMessagesContext(DraftMessageSessionStoreCache);

  return (
    <DraftMessagesProviderContext.Provider value={draftMessagesState}>
      {children}
    </DraftMessagesProviderContext.Provider>
  );
};
